import { Injectable } from '@angular/core';
import { formatDateTimeInternal } from '@core/_utils/date.utils';
import { encodeUtf8 } from '@core/_utils/tools.utils';

@Injectable()
export class FormatRequestTools {
    private _action: string;
    private _docId: string;
    private _currentDocName: string;

    constructor() {
        this.clear('');
    }

    public clear(aDocId) {
        this.action = '';
        this.docId = aDocId;
        this.currentDocName = '';
    }

    public actionUpdate(aInfoMail) {
        let wRequest;
        let wExtended;
        let wBaseInfos;
        wBaseInfos = {
            Docid: this.docId,
            DstBasketName: aInfoMail.dstBasketName,
        };
        switch (this.action) {
            case 'validbskaction': {
                wExtended = {
                    Wkfid: aInfoMail.wkfid,
                    Button: aInfoMail.button,
                    Label: aInfoMail.label,
                };
                wRequest = this.formatParamList(wBaseInfos, wExtended);
                break;
            }
            case 'validbsk': {
                wRequest = this.formatParamList(wBaseInfos, {});
                break;
            }
            case 'mailinsert':
            case 'savemail':
            case 'validmail': {
                wExtended = {
                    DocStatus: encodeUtf8(aInfoMail.status),
                    Wkfid: aInfoMail.msgId,
                    MailAction: aInfoMail.mailAction,
                    MailLimit: aInfoMail.mailLimit,
                    MailUrgent: aInfoMail.mailUrg,
                    MailConfidential: aInfoMail.mailConf,
                };
                wRequest = this.formatParamList(wBaseInfos, wExtended);
                break;
            }
            case 'mailcopy':
            case 'mailmove': {
                wExtended = {
                    SrcBasketName: aInfoMail.SrcBasketName,
                    DocStatus: encodeUtf8(aInfoMail.status),
                    Wkfid: aInfoMail.msgId,
                    MailAction: aInfoMail.mailAction,
                    MailLimit: aInfoMail.mailLimit,
                    MailUrgent: aInfoMail.mailUrg,
                    MailConfidential: aInfoMail.mailConf,
                };
                wRequest = this.formatParamList(wBaseInfos, wExtended);
                break;
            }
            case 'insert': {
                wRequest = this.formatParamList(wBaseInfos, {});
                break;
            }
            case 'copy':
            case 'move': {
                wExtended = {
                    SrcBasketName: aInfoMail.SrcBasketName,
                };
                wRequest = this.formatParamList(wBaseInfos, wExtended);
                break;
            }
            case 'duplicate': {
                wRequest = {
                    Command: this.getCommandValue(),
                    Docid: this.docId,
                    SrcBasketName: aInfoMail.SrcBasketName,
                    DstBasketName: aInfoMail.dstBasketName,
                }                
                break;
            }
            case 'mailduplicate': {
                wRequest = {
                    Command: this.getCommandValue(),
                    Docid: this.docId,
                    SrcBasketName: aInfoMail.SrcBasketName,
                    DstBasketName: aInfoMail.dstBasketName,
                    DstBasketType: 'Mail',
                    DocStatus: encodeUtf8(aInfoMail.status),
                    Flow: aInfoMail.msgId,
                    MailAction: aInfoMail.mailAction,
                    MailLimit: aInfoMail.mailLimit,
                    MailUrgent: aInfoMail.mailUrg,
                    MailConfidential: aInfoMail.mailConf,
                }   
                break;
            }
        }
        return wRequest;
    }

    public checkout(aUserName) {
        let wRequest;
        let wdate;
        wdate = formatDateTimeInternal(new Date());
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                CheckOut: {
                    Date: wdate,
                    Value: encodeUtf8(aUserName),
                },
            },
        };
        return wRequest;
    }

    public checkin() {
        let wRequest;
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                CheckIn: true,
            },
        };
        return wRequest;
    }

    public setIndex(aEditorService, aVariableList, aRequest) {
        let wRequest;
        let VariableList = new Array();
        let wValue;
        let wRequestItem: any = {};
        for (let i = 0; i < aVariableList.length; i++) {
            if (aVariableList[i].type !== 'separator') {
                wValue = aEditorService.getValueFromType(aVariableList[i], aRequest);
                if (typeof wValue === 'string') {
                    wValue = encodeUtf8(wValue);
                }
                wRequestItem = {
                    Variable: { Name: aVariableList[i].name, Type: aVariableList[i].type, Value: wValue },
                };
                VariableList.push(wRequestItem);
            }
        }
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                Variables: {
                    VariableList,
                },
            },
        };
        return wRequest;
    }

    public sendBasket(aEditorService, aVariableList, aRequest, aInfoMail, aCurrentAtf) {
        let wRequest;
        let VariableList = new Array();
        let wValue;
        let wRequestItem: any = {};
        for (let i = 0; i < aVariableList.length; i++) {
            if (aVariableList[i].type !== 'separator') {
                wValue = aEditorService.getValueFromType(aVariableList[i], aRequest);
                if (typeof wValue === 'string') {
                    wValue = encodeUtf8(wValue);
                }
                wRequestItem = {
                    Variable: { Name: aVariableList[i].name, Type: aVariableList[i].type, Value: wValue },
                };
                VariableList.push(wRequestItem);
            }
        }
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                AtfToBsk: {
                    Variables: {
                        VariableList,
                    },
                    InfoMail: aInfoMail,
                    AtfName: aCurrentAtf
                }
            },
        };
        return wRequest;
    }

    public setComment(aComment, aUserName) {
        let wRequest;
        let wdate;
        wdate = formatDateTimeInternal(new Date());
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                Comments: {
                    CommentList: {
                        Comment: {
                            Date: wdate,
                            User: aUserName,
                            Value: encodeUtf8(aComment),
                        },
                    },
                },
            },
        };
        return wRequest;
    }

    public setChangeDoc(aRoot, aPath, aName) {
        let wRequest;
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                Move: {
                    Root: aRoot,
                    Path: aPath,
                    FileName: aName,
                },
            },
        };
        return wRequest;
    }

    public setUpdateThumbs() {
        let wRequest;
        wRequest = {
            Docid: this.docId,
            UpdateList: {
                UpdateActivityDate: false,
                UpdateThumbs: true,
            },
        };
        return wRequest;
    }

    public deletebsk(aInfoMail) {
        let wRequest;
        let wExtended;
        let wBaseInfos;
        if (aInfoMail !== null) {
            wBaseInfos = {
                Docid: this.docId,
                DstBasketName: aInfoMail.dstBasketName,
            };
        }
        wExtended = {
            SrcBasketName: aInfoMail.SrcBasketName,
        };
        wRequest = this.formatParamList(wBaseInfos, wExtended);
        return wRequest;
    }

    public deleteGed(aArchiv) {
        let wRequest;
        wRequest = { 
            Docid: this.docId, AddArchiv: aArchiv, DocName: this.currentDocName };
        return wRequest;
    }

    private formatParamList(wBaseInfos, wExtended = {}) {
        return {
            Command: this.getCommandValue(),
            ParamList: {
                ...wBaseInfos,
                ...wExtended,
            },
            DocName: this.currentDocName,
        };
    }

    private getCommandValue() {
        const listCommand = {
            validbskaction: 'Validate',
            validbsk: 'Validate',
            validmail: 'Validate',
            savemail: 'Insert',
            mailinsert: 'Insert',
            insert: 'Insert',
            mailcopy: 'Copy',
            copy: 'Copy',
            mailmove: 'Move',
            move: 'Move',
            deletebsk: 'Move',
            deleteged: 'Delete',
            duplicate: 'CloneDocument',
            mailduplicate: 'CloneDocument',
        };
        return listCommand[this.action];
    }

    public bskValid(aCurrentSelectedBsk) {
        return {
            dstBasketName: aCurrentSelectedBsk.bskName,
        };
    }

    public bskAction(aCurrentSelectedBsk, aCurrentBskProperty, aAction) {
        if (aAction === -1) {
            return this.bskActionValid(aCurrentSelectedBsk, aCurrentBskProperty);
        } else {
            return this.bskActionValidAct(aCurrentSelectedBsk, aCurrentBskProperty, aAction);
        }
    }

    private bskActionValid(aCurrentSelectedBsk, aCurrentBskProperty) {
        return {
            dstBasketName: aCurrentSelectedBsk.bskName,
            label: 'Valider',
            wkfid: aCurrentBskProperty.bsk_wkfid,
        };
    }

    private bskActionValidAct(aCurrentSelectedBsk, aCurrentBskProperty, aAction) {
        return {
            dstBasketName: aCurrentSelectedBsk.bskName,
            button: 'Button' + (aAction + 1),
            label: encodeUtf8(aCurrentSelectedBsk.bskbuttonList[aAction].Label),
            wkfid: aCurrentBskProperty.bsk_wkfid,
        };
    }

    public setActionDoc(aAction, aDocId, aPosition, aUpdateValue, aDimension, aPage) {
        let wRequest;
        let wPosx: any;
        let wPosy: any;
        wPosx = Math.round((aPosition.x / aDimension.x) * 100);
        wPosy = Math.round((aPosition.y / aDimension.y) * 100);
        const type = {
            addtextpdf: this.addtextpdf,
            stamp: this.stamp,
            annot: this.annot,
            graphsign: this.graphsign,
        }
        if (type[aAction]) {
            wRequest = { 
                Docid: aDocId, ActionList: type[aAction] (encodeUtf8, aUpdateValue, aPage, wPosx, wPosy)};
        }
        return wRequest;
    }

    private addtextpdf(aEncodeUtf8, aUpdateValue, aPage, aPosx, aPosy) {
        return {
            AddTextPdf: {
                Page: aPage,
                Text: aEncodeUtf8(aUpdateValue.addtextpdf),
                // Font: '',
                // Size: aUpdateValue.size,
                Color: aUpdateValue.color,
                Opacity: 50,
                Posx: aPosx,
                Posy: aPosy,
            },
        }
    }

    private stamp(aEncodeUtf8, aUpdateValue, aPage, aPosx, aPosy) {
        return {
            Stamp: {
                Page: aPage,
                Text: aEncodeUtf8(aUpdateValue.text),
                // Font: '',
                Size: aUpdateValue.size,
                Color: aUpdateValue.color,
                Opacity: 50,
                Posx: aPosx,
                Posy: aPosy,
            },
        }
    }
    
    private annot(aEncodeUtf8,aUpdateValue, aPage, aPosx, aPosy) {
        return {
            Comment: {
                Page: aPage,
                Type: aUpdateValue.type,
                Title: aEncodeUtf8(aUpdateValue.title),
                Text: aEncodeUtf8(aUpdateValue.text),
                Color: aUpdateValue.color,
                Open: true,
                Posx: aPosx,
                Posy: aPosy,                
            },
        }
    }
    
    private graphsign(aEncodeUtf8, aUpdateValue, aPage, aPosx, aPosy) {
        return {
            GraphicSignature: {
                Page: aPage,
                Reason: aEncodeUtf8(aUpdateValue.reason),
                Posx: aPosx,
                Posy: aPosy,
            },
        }
    }

    get action() {
        return this._action;
    }

    set action(aValue) {
        this._action = aValue;
    }

    get docId() {
        return this._docId;
    }

    set docId(aValue) {
        this._docId = aValue;
    }

    get currentDocName() {
        return this._currentDocName;
    }

    set currentDocName(aValue) {
        this._currentDocName = aValue;
    }
}
